import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { NumberedList } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Step extends SbBlokData {
  text: string;
}

interface Blok extends PageSectionBlok {
  title: string;
  steps: Step[];
  hasDivider: boolean;
}

interface StepsProps extends PageSectionProps {
  blok: Blok;
}

export const Steps: FunctionComponent<React.PropsWithChildren<StepsProps>> = ({ blok, sectionClassName }) => {
  const { hasDivider, hasBackground, hasBorder, title, steps = [], hasPaddingBottom, hasPaddingTop } = blok;

  const numberedList = steps.map(({ text }, index) => ({
    displayNumber: index + 1,
    displayText: text
  }));

  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      <NumberedList numberedList={numberedList} showDivider={hasDivider} />
    </Section>
  );
};
